const instances = new Map();

const nextPage = (slider) => (event) => {
	// const breakpoint = slider.getBreakpoint(slider.params.breakpoints);
	// const step = slider.params.breakpoints[breakpoint]?.slidesPerView;

	// slider.slideTo(slider.activeIndex + step);
	slider.slideTo(slider.activeIndex + 1);
}

const prevPage = (slider) => (event) => {
	// const breakpoint = slider.getBreakpoint(slider.params.breakpoints);
	// const step = slider.params.breakpoints[breakpoint]?.slidesPerView;

	// slider.slideTo(slider.activeIndex - step);
	slider.slideTo(slider.activeIndex - 1);
}

const paginationHandler = (prevEl, nextEl) => (slider) => {
	const { isBeginning, isEnd } = slider;

	if (isBeginning)
		prevEl.disabled = true;
	else
		prevEl.disabled = false;

	if (isEnd)
		nextEl.disabled = true;
	else
		nextEl.disabled = false;
}

// initialisation swiper

async function initHomepageSwiper(carousel) {

	const { default: Swiper } = await import('swiper/bundle');

	// if (instances.has(homepageSwiper))
	//   return;

	const nextThumb = carousel.querySelector('.homepage-swiper-button-next-custom');
	const prevThumb = carousel.querySelector('.homepage-swiper-button-prev-custom');

	// hidding empty slides

	// const swiperSlide = rootElement.querySelectorAll('.swiper-slide');

	// function hideElemIfEmpty(elm) {
	//   if (elm.children.length === 0) {
	//     elm.parentNode.removeChild(elm);
	//   }
	// }

	// swiperSlide.forEach(hideElemIfEmpty);

	// const className = test;

	const homepageSwiper = new Swiper(carousel, {
		speed: 350,
		slidesPerView: 1,
		// breakpoints: {
		//   0: {
		//     slidesPerView: 4,
		//   },
		//   850: {
		//     slidesPerView: 5,
		//   },
		// },
		init: false,
		autoplay: {
			delay: 4000,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			renderBullet: function (index, className) {
				return '<span class="' + className + '">' + '0' + (index + 1) + "</span>";
			},
		},
	});

	instances.set(carousel, homepageSwiper);


	const customNextPageHandler = nextPage(homepageSwiper);
	const customPrevPageHandler = prevPage(homepageSwiper);
	const customPaginationHandler = paginationHandler(prevThumb, nextThumb);

	homepageSwiper.on('init', customPaginationHandler);
	homepageSwiper.on('activeIndexChange', customPaginationHandler);

	homepageSwiper.on('init', () => {
		nextThumb.addEventListener('click', customNextPageHandler);
		prevThumb.addEventListener('click', customPrevPageHandler);
	});

	homepageSwiper.on('beforeDestroy', () => {
		nextThumb.removeEventListener('click', customNextPageHandler);
		prevThumb.removeEventListener('click', customPrevPageHandler);
		instances.delete(homepageSwiper);
	});

	homepageSwiper.init();


	// return homepageSwiper;
}

const root = document.querySelector('.homepage-swiper');


document.addEventListener('DOMContentLoaded', () => {

	if (root) {
		const carouselContainer = document.querySelector(".homepage-swiper-carousel");
		initHomepageSwiper(carouselContainer)
	}
});
